import React from 'react';
import {Authenticator} from "@aws-amplify/ui-react";
import SearchBooksInterface from "../components/SearchBooksInterface";

const SearchBooksPage = () => {
    return (
        <Authenticator hideSignUp={true} variation={"modal"}>
            {({signOut, user}) => (
                <div className="container">
                    <SearchBooksInterface/>
                </div>
            )}
        </Authenticator>
    );
}

export default SearchBooksPage;